import { useState, useEffect } from 'react'

import Select, { components } from 'react-select'
import { useTranslation } from 'react-i18next'
import { Form, Badge } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'

import './multipleSelect.scss'

// Custom Dropdown Indicator
const CustomDropdownIndicator = (props) => {
    const { dmode } = props.selectProps
    return (
        <components.DropdownIndicator {...props}>
            <FeatherIcon
                icon="plus"
                size="18"
                color={dmode ? '#fff' : '#000'}
            />{' '}
            {/* Example usage of dmode */}
        </components.DropdownIndicator>
    )
}

const SelectComponent = ({
    dmode,
    options,
    label,
    placeholder,
    selectVal,
    setSelectVal,
    name,
    dir = 'ltr',
    isMulti = true,
    isDisabled = false,
}) => {
    const [val, setVal] = useState(options)
    const { t } = useTranslation()

    useEffect(() => {
        setVal(options)
    }, [options?.length])

    const removeValue = (valueToRemove) => {
        setSelectVal(
            selectVal.filter((value) => value.value !== valueToRemove.value),
            name
        )
    }

    const MultiValue = () => {
        return null
    }

    // Custom filter function to prioritize exact or starts-with matches
    const filterOptions = (candidate, input) => {
        const inputLower = input.toLowerCase()
        const labelMatch = candidate?.data?.label
            .toLowerCase()
            .includes(inputLower)
        const codeMatch = candidate?.data.code
            ?.toLowerCase()
            .includes(inputLower)
        const startsWith = candidate?.data?.label
            .toLowerCase()
            .startsWith(inputLower)
        return startsWith || labelMatch || codeMatch
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f0f0f0' : '#fff', // Hover color
            color: '#333',
            padding: 10,
        }),
        control: (provided) => ({
            ...provided,
            border: '1px solid none',
            borderColor: dmode ? '#2cc990' : `#828282`,
            backgroundColor: 'inherit',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid none',
                cursor: 'pointer',
            },
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: dmode ? 'white !important' : 'black', // Color for selected value
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuList: (provided) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            width: '0.5px',
            margin: '0',
            height: '100%',
            backgroundColor: dmode
                ? '#2cc990 !important'
                : '#828282 !important',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            backgroundColor: dmode ? 'transparent' : '#F2F1FF',
            height: 37,
            borderRadius:
                dir === 'ltr'
                    ? '0 4px 4px 0 !important'
                    : ' 4px 0  0 4px !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#333333',
        }),
        input: (provided) => ({
            ...provided,
            color: dmode ? 'white !important' : 'black !important',
        }),
    }

    return (
        <>
            <Form.Group className="mb-2" dir={dir}>
                {label ? (
                    <Form.Label className="glo-label">{t(label)}</Form.Label>
                ) : (
                    <Form.Label
                        className="glo-label"
                        style={{ color: 'transparent' }}
                    >
                        *
                    </Form.Label>
                )}
                <Select
                    styles={customStyles}
                    isMulti={isMulti}
                    value={selectVal}
                    onChange={(selectedOptions) => {
                        setSelectVal(selectedOptions, name)
                    }}
                    options={val}
                    placeholder={t(placeholder)}
                    className={`select ${dmode && 'select-dark'}`}
                    components={{
                        DropdownIndicator: (props) => (
                            <CustomDropdownIndicator
                                {...props}
                                selectProps={{ dmode }}
                            />
                        ),
                        MultiValue,
                    }}
                    isClearable
                    isDisabled={isDisabled}
                    filterOption={filterOptions}
                />
                {isMulti && (
                    <div className="list_ad mt-3">
                        {selectVal?.map((value, index) => (
                            <Badge
                                key={index}
                                pill
                                variant="light"
                                className="badge-select-ad"
                                dir={dir}
                            >
                                {value?.label}
                                <span
                                    className="remove-badge"
                                    onClick={() => removeValue(value)}
                                    dir={dir}
                                >
                                    &times;
                                </span>
                            </Badge>
                        ))}
                    </div>
                )}
            </Form.Group>
        </>
    )
}

export default SelectComponent
